/* The above code is a React component that is used to generate a digital card. */
import React, { useState, useContext, useCallback, useEffect, memo } from "react";

//context
import { AuthContext } from "../../../../common/middlewares/Auth";

//material-ui
import {
    Card,
    Box,
    CardActionArea,
    CardHeader,
    CardMedia,
    Typography,
    useTheme,
    useMediaQuery,
    Divider,
    Avatar,
    Grid,
    Tooltip,
} from "@mui/material";

//Librerias
import axios from "axios";
import { toast } from "react-hot-toast"
import { createStyles } from "@mui/material/styles";
import html2canvas from "html2canvas";
import { QRCodeSVG } from "qrcode.react";

//imagenes
import Carnet from "../../../../static/images/CarnetDigitalBackground.png";
import LogoChoucair from "../../../../static/images/logoChoucair.jpg";
import AvatarRobot from "../../../../static/images/avatarRobot.png";

//Iconos

// componentes
import ModalSubirFoto from "./modalSubirFoto";
//import ModalPdf from "./modalPDF";

//Hooks
import useGetPersonActiva from "../../../../common/hooks/usePersonaActiva";
//import useShortLink from "../../../hooks/useShortLink";

const CarnetStyles = createStyles((theme) => ({}));

const CarnetDigital = () => {
    //===============================================================================================================================================
    //==================================================== Context ==================================================================================
    //===============================================================================================================================================
    /* Getting the context from the AuthContext.js file. */
    const authContext = useContext(AuthContext);
    const { strInfoUser, token } = authContext;

    const { data } = useGetPersonActiva({
        strEmailColaborador: strInfoUser?.strEmail,
    });

    /* const { dataUrl } = useShortLink({
         strEmailColaborador: strInfoUser.strEmail,
         url:`https://wilson.choucairtesting.com/carnetdigital/verificacion/${strInfoUser.strEmail}`
     });*/

    //========================================================================================================================
    //========================================= Estados  =====================================================================
    //========================================================================================================================
    /* Setting the state of the file, open, autoload, and loading. */
    const [file, setFile] = useState(null);
    const [open, setOpen] = useState(false);
    const [autoload, setAutoLoad] = useState(false);
    const [loading, setLoading] = useState(false);
    const [imgError, setImgError] = useState(false);
    //const [openPdf, setOpenPdf] = useState(false);
    //========================================================================================================================
    //========================================= Funciones  ===================================================================
    //========================================================================================================================
    /* A function that is being called by another function. */
    const getFile = useCallback(
        async ({ signalSubmitData, strEmailColaborador }) => {
            setLoading(true);
            return await axios(
                {
                    method: "GET",
                    baseURL: `${process.env.REACT_APP_PROTOCOL_BACKEND}://${process.env.REACT_APP_HOST_BACKEND}${process.env.REACT_APP_PORT_BACKEND}`,
                    url: `${process.env.REACT_APP_API_GET_GETLINKFOTOCARNET}`,
                    params: {
                        strEmailColaborador,
                    },
                    headers: {
                        token,
                    },
                },
                {
                    cancelToken: signalSubmitData.token,
                }
            )
                .then((res) => {
                    setFile(res.data.data?.strUrlFoto);
                    setImgError(false);
                    setLoading(false);
                    return res.data.data?.strUrlFoto;
                })
                .catch((error) => {
                    setLoading(false);

                    if (!axios.isCancel(error)) {
                        let msg;

                        if (error.response) {
                            msg = error.response.data.msg;
                        } else if (error.request) {
                            msg = error.message;
                        } else {
                            msg = error.message;
                        }

                        // toast.error(error.message
                        //     ? error.message
                        //     : "Ha ocurrido un error inesperado al enviar los datos de info basica",)

                        setFile({
                            error: true,
                            msg,
                        });

                        return {
                            error: true,
                            msg,
                        };
                    }
                });
        },
        [token]
    );
    /**
     * If the file is not empty, then set the open state to false.
     */

    const handleOpen = () => {
        if (!file) {
            setOpen(!open);
        } else {
            setOpen(false);
        }
    };

    /* const handleOpenPdf = () => {
    setOpenPdf(!openPdf);
  };*/

    /**
     * I'm trying to get the image from the server and then convert it to a canvas and then download it as
     * a png file.
     */

    const handleOpenCanvas = async () => {
        await html2canvas(document.querySelector("#CarnetDigital"), {
            proxy: `${process.env.REACT_APP_PROTOCOL_BACKEND_CARNET}://${process.env.REACT_APP_HOST_BACKEND_CARNET}${process.env.REACT_APP_PORT_BACKEND_CARNET}${file}`,
        }).then((canvas) => {
            var image = canvas
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");
            var a = document.createElement("a");
            a.href = image;
            a.download = "CarnéDigital.png";
            a.click();
        });
    };

    //===============================================================================================================================================
    //========================================== useEffects =========================================================================================
    //===============================================================================================================================================
    /* A useEffect hook that is executed when the component is mounted. */
    useEffect(() => {
        let signalSubmitData = axios.CancelToken.source();

        if (autoload) {
            getFile({
                signalSubmitData,
                strEmailColaborador: strInfoUser?.strEmail,
            });
        }

        return () => {
            signalSubmitData.cancel("Petición abortada.");
        };
    }, [getFile, autoload, strInfoUser]);

    /* A useEffect hook that is calling the getFile function. */
    useEffect(() => {
        let signalSubmitData = axios.CancelToken.source();
        getFile({
            signalSubmitData,
            strEmailColaborador: strInfoUser?.strEmail,
        });
        return () => {
            signalSubmitData.cancel("Petición abortada.");
        };
    }, [getFile, strInfoUser]);

    //===============================================================================================================================================
    //========================================== Hooks personalizados ===============================================================================
    //===============================================================================================================================================
    /* Using the useTheme hook to get the theme object and then using the useMediaQuery hook to get the
  breakpoints object. */
    const theme = useTheme();
    const movil = useMediaQuery(theme.breakpoints.down("sm"));

    //===============================================================================================================================================
    //========================================== Renders ===============================================================================
    //===============================================================================================================================================
    /* Importing the styles from the CarnetStyles.js file. */
    const classes = CarnetStyles();

    /* The above code is a React component that is used to display a card with a QR code. */
    return (
        <>
            {/* A modal that is being called from another component. */}
            <Box position="absolute" >
                <ModalSubirFoto
                    open={open}
                    handleOpenDialog={handleOpen}
                    setAutoLoad={setAutoLoad}
                />
                {/* <ModalPdf 
        open={openPdf} 
        handleOpenDialog={handleOpenPdf} />*/}
            </Box>
            {/* A card that is displayed in a grid, it has a button that opens a modal, and it has a QR code
      that is displayed when the user uploads a photo. */}
            <Grid item xs={12} sm={3}>
                <Card
                    style={{
                        height: "100%",
                    }}
                >
                    {/* A React component that is rendering a card with a QR code and a photo. */}
                    <Tooltip title={!file ? "Clic para subir foto" : ""} followCursor>
                    <CardActionArea
                        onClick={
                            !file
                                ? () => handleOpen()
                                : () => handleOpenCanvas()
                        }
                        disabled={loading}
                    >
                        {/* Creating a card header with a title and subtitle. */}
                        <CardHeader
                            style={{
                                paddingBottom: "10px",
                                marginLeft: "25%",
                                marginRight: "25%",
                            }}
                            title={<b>Carné Digital</b>}
                            titleTypographyProps={{
                                variant: "subtitle1",
                                gutterBottom: true,
                                align: "center",
                                component: "h5",
                            }}
                        />
                        {/* Creating a card with a background image, a logo, an avatar, a QR code, and some text. */}
                        <CardMedia style={{ display: "flex", justifyItems: "center", justifyContent: "center" }}>
                            <Box
                                display="flex"
                                flexDirection="row"
                                id="CarnetDigital"
                                style={{
                                    border: "1px solid #000",
                                }}
                            >
                                <Box
                                    display="flex"
                                    position="relative"
                                    justifyContent="center"
                                >
                                    {/* A React component that is rendering an image. */}
                                    <img
                                        src={Carnet}
                                        alt="Background Carnet"
                                        style={{
                                            width: "375px",
                                            height: "408px",
                                        }}
                                    />
                                    <Box
                                        position="absolute"
                                        sx={
                                            movil
                                                ? {
                                                    marginTop: "3%",
                                                }
                                                : {
                                                    marginTop: "3%",
                                                }
                                        }
                                    >
                                        <img
                                            src={LogoChoucair}
                                            alt="Logo Choucair"
                                            className={{
                                                width: "100%",
                                                height: "100%",
                                                maxWidth: "100%",
                                            }}
                                        />
                                    </Box>
                                    {/* Rendering an avatar if the file is true, otherwise it is rendering an avatar with a
                cloud upload icon and a text. */}
                                    <Box
                                        position="absolute"
                                        style={
                                            movil
                                                ? {
                                                    marginTop: "20%",
                                                }
                                                : {
                                                    marginTop: "20%",
                                                }
                                        }
                                    >
                                        {file && !imgError ? (
                                            <Avatar
                                                src={`${process.env.REACT_APP_PROTOCOL_BACKEND_CARNET}://${process.env.REACT_APP_HOST_BACKEND_CARNET}${process.env.REACT_APP_PORT_BACKEND_CARNET}${file}`}
                                                alt="avatar"
                                                slotProps={{
                                                    img: {
                                                        onError: () => setImgError(true),
                                                    },
                                                }}
                                                style={{
                                                    width: 140,
                                                    height: 140,
                                                    borderRadius: "140px",
                                                    border: "1px solid #A6ACAF",
                                                }}
                                            />
                                        ) : (
                                            <Avatar
                                                src={AvatarRobot}
                                                alt="avatar"
                                                style={{
                                                    width: 140,
                                                    height: 140,
                                                    borderRadius: "140px",
                                                    border: "1px solid #A6ACAF",
                                                }}
                                            />
                                        )}
                                    </Box>
                                    <Box
                                        position="absolute"
                                        style={{
                                            marginTop: "60%",
                                            color: "#fff",
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                textTransform: "uppercase",
                                                marginBottom: "0",
                                                fontSize: "14px",
                                            }}
                                        >
                                            <b>{data?.strNombreCompleto}</b>
                                        </Typography>
                                        <Divider
                                            orientation="horizontal"
                                            style={{
                                                background: "#FFF",
                                                margin: "2px",
                                            }}
                                        />
                                    </Box>
                                    <Box
                                        position="absolute"
                                        style={{
                                            marginTop: "70%",
                                            color: "#fff",
                                        }}
                                    >
                                        <Typography
                                            align="center"
                                            style={{
                                                textTransform: "capitalize",
                                                marginTop: "0",
                                                alignItems: "center",
                                                fontSize: "12px",
                                            }}
                                        >
                                            {data?.strCargo}
                                        </Typography>
                                    </Box>
                                    {/* Creating a QR code that is being displayed on the screen. */}
                                    <Box
                                        position="absolute"
                                        style={{
                                            marginTop: "80%",
                                            marginRight: "40%",
                                        }}
                                    >
                                        {file ? (
                                            <QRCodeSVG
                                                includeMargin
                                                size="100"
                                                value={
                                                    process.env
                                                        .REACT_APP_NODE_ENV ===
                                                        "development"
                                                        ? `http://172.17.27.67:11002/carnetdigital/verificacion/${strInfoUser?.strEmail}`
                                                        : process.env
                                                            .REACT_APP_NODE_ENV ===
                                                            "production"
                                                            ? `https://wilson.choucairtesting.com/carnetdigital/verificacion/${strInfoUser?.strEmail}`
                                                            : null
                                                }
                                            />
                                        ) : null}
                                    </Box>
                                    {/* Creating a box with a position of absolute and then placing it on the page with a
                margin of 90% from the top and 60% from the left. It is then creating a Typography
                element with a textTransform of capitalize and a marginTop of 25% and a fontSize of
                12px. It is then creating another Typography element with a textTransform of
                    capitalize and a marginTop of 0 and a fontSize of 12px. */}
                                    <Box
                                        position="absolute"
                                        style={{
                                            marginTop: "80%",
                                            marginLeft: "45%",
                                            color: "#FFF",
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                textTransform: "capitalize",
                                                marginTop: "25%",
                                                fontSize: "12px",
                                            }}
                                        >
                                            <b>
                                                {data?.strtipoIdentificacion}{" "}
                                            </b>
                                            : {data?.strIdentificacion}
                                        </Typography>
                                        <Typography
                                            style={{
                                                textTransform: "capitalize",
                                                marginTop: "0",
                                                fontSize: "12px",
                                            }}
                                        >
                                            <b>RH </b>:{" "}
                                            {data?.strGrupoSanguineo}
                                            {data?.strRh === "P" ? "+" : "-"}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </CardMedia>
                    </CardActionArea>
                    </Tooltip>
                </Card>
            </Grid>
        </>
    );
};

export default memo(CarnetDigital);
